import React from 'react';
import {useLocation} from 'react-router-dom';
import RequireOrgAccess from './RequireOrgAccess';

// People and celebrations share a legacy URL with service attendance, but not
// its permission. Keep unknown/admin views behind the existing attendance gate.
export function attendanceWorkspaceRequirement(search = '') {
  const view = new URLSearchParams(search).get('view');
  // Attendance staff could already open these views; retain that access.
  if (view === 'people' || view === 'celebrations') return ['canManagePeople', 'canManageAttendance'];
  return 'canManageAttendance';
}

export default function AttendanceWorkspaceBoundary({children}) {
  const {search} = useLocation();
  const permission=attendanceWorkspaceRequirement(search);
  const requirement=Array.isArray(permission) ? permission : {organizationCapability:'serviceAttendance',permission};
  return <RequireOrgAccess require={requirement}>{children}</RequireOrgAccess>;
}
